export const ErrorCodes = {
  User: {
    EMAIL_REGISTERED: 'user.update.email_registered',
  },
};
